import { createSlice } from '@reduxjs/toolkit';

const mapSearchSlice = createSlice({
  name: 'mapSearch',
  initialState: {
    selectedCity: undefined,
    cityList: [],
  },
  reducers: {
    setSelectedCity: (state, action) => {
      return {
        ...state,
        selectedCity: action.payload,
      };
    },
    setCityList: (state, action) => {
      return {
        ...state,
        cityList: action.payload,
      };
    },
  },
});

export const { setSelectedCity, setCityList } = mapSearchSlice.actions;
export default mapSearchSlice.reducer;
